export const en = {
    'table-streams-copy-link-title-permanent': 'Permanent link to the stream',
    'table-streams-copy-link-title': 'Link to the stream',
    stream: 'Stream',
    chat: 'Chat',
    'copy-stream-link': 'Copy stream link',
    'copy-chat-link': 'Copy chat link',
};
